// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Zuu3","title":"Info_title__1Aqm0","links":"Info_links__25MAW","link":"Info_link__1L7l_","logo":"Info_logo__2CaeT"};